<template>
    <q-icon name="sym_o_help" style="font-size: 2.333vmin; color: #bdbdbd">
        <!-- <q-icon name="img:assets/images/icon/ico_tip.svg"> -->
        <q-popup-proxy>
            <div class="q-dialog-plugin" :style="props.width ? 'width:' + props.width : ''">
                <div style="padding: 2.66vmin; display: inline-flex">
                    <div>
                        <slot></slot>
                    </div>
                    <div style="margin-left: 20px">
                        <q-icon name="img:/assets/images/icon/ico_close.svg" :onclick="onClickHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" v-close-popup />
                    </div>
                </div>
            </div>
        </q-popup-proxy>
    </q-icon>
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';

const props = defineProps({
    width: {
        default: null,
    },
});

onMounted(() => {});

onUnmounted(() => {
    // root.dispose();
});
</script>

<style scoped lang="scss">
.q-dialog-plugin {
    width: 31.25vw;
    background: #ffffff;
    border: 1px solid #e0e0e0;
    box-shadow: 0px 10px 36px rgba(0, 0, 0, 0.3);
    border-radius: 16px;
    position: fixed !important;
}
</style>
